import { render, staticRenderFns } from "./LayoutMainPages.vue?vue&type=template&id=44ec21ba&scoped=true&"
import script from "./LayoutMainPages.vue?vue&type=script&lang=js&"
export * from "./LayoutMainPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ec21ba",
  null
  
)

export default component.exports